import React, { useContext, useState } from 'react';
import classNames from 'classnames';

import { withViewport } from '../../../../util/contextHelpers';
import {
    ModalPortal,
    ImageCarousel,
    IconSpinner,
    SdkVideo,
    Button,
    AnonymCarouselPlaceholder,
} from '../../../../components';

import css from './SectionImages.css';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useAssets } from '../../../../hooks/useAssets';
import GalleryIcon from '../../../../forms/ProfileSettingsForm/icons/GalleryIcon';
import { checkIfListingIsAnonymous } from '../../../../util/anonym';
import ActionButton from '../SectionContact/ActionButton';
import { ListingPageContext } from '../../ListingPage';
import { Thumbnail } from '../../../../components/AddImages/Thumbnail';

const SectionImages = ({
    title,
    listing,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    selectedImageIndex,
    assetsLoadingRequests,
    isMobile,
    // isOwnerView,
    loading: loadingProp,
    riderListing,
    children,
}) => {
    const { setInquiryModalOpen } = useContext(ListingPageContext);

    const { uuid } = listing.id;

    const loading = assetsLoadingRequests && assetsLoadingRequests[uuid];
    const isAnonymousListing = /*!isOwnerView && */ checkIfListingIsAnonymous(listing);

    const images = useAssets({ listing });

    const hasImages = images && images.length > 0;
    const firstImage = hasImages ? images[0] : null;
    const secondImage = hasImages ? images[1] : null;

    const viewPhotosButton = hasImages ? (
        <Button className={css.viewPhotos} onClick={handleViewPhotosClick}>
            <GalleryIcon />
        </Button>
    ) : null;
    const { length } = images || [];
    const gallerySecondaryColumns = isMobile ? 0 : length === 3 ? 1 : length > 3 ? 2 : 0;

    const imageProps = {
        variants: ['landscape-crop', 'landscape-crop2x', 'landscape-crop4x', 'landscape-crop6x'],
        alt: title,
        rootClassName: css.rootForImage,
    };

    const videoProps = { autoPlay: true };

    const galleryColumns = Array.from({ length: gallerySecondaryColumns }, (_, i) => {
        const fIndex = i + 1;
        const sIndex = i + 2;
        const isSingleImageColumn = !images[i + sIndex];
        return (
            <div
                className={classNames(css.galleryColumn, {
                    [css.singleImageInColumn]: isSingleImageColumn,
                })}
            >
                <div className={css.gallerySecondaryImageContainer}>
                    <Thumbnail
                        asset={images[i + fIndex]}
                        onPreviewClick={e => handleViewPhotosClick(e, i + fIndex)}
                        hiddenAsset={isAnonymousListing}
                        imageProps={{
                            sizes: '25vw',
                            ...imageProps,
                        }}
                        videoProps={videoProps}
                    />
                </div>

                {!isSingleImageColumn && (
                    <div className={css.gallerySecondaryImageContainer}>
                        <Thumbnail
                            asset={images[i + sIndex]}
                            onPreviewClick={e => handleViewPhotosClick(e, i + sIndex)}
                            hiddenAsset={isAnonymousListing}
                            imageProps={{
                                sizes: '25vw',
                                ...imageProps,
                            }}
                            videoProps={videoProps}
                        />
                    </div>
                )}
            </div>
        );
    });

    const imagesPair = secondImage && !gallerySecondaryColumns;

    return (
        <>
            <div className={css.threeToTwoWrapper}>
                <div className={css.aspectWrapper}>
                    {loading ? (
                        <IconSpinner />
                    ) : (
                        <div
                            className={classNames(css.galleryImagesWrapper, {
                                [css.imagesPair]: !!imagesPair,
                            })}
                        >
                            <div className={css.galleryMainImageContainer}>
                                <Thumbnail
                                    asset={firstImage}
                                    hiddenAsset={isAnonymousListing}
                                    onPreviewClick={e => handleViewPhotosClick(e, 0)}
                                    imageProps={imageProps}
                                    videoProps={videoProps}
                                />
                            </div>
                            {imagesPair && (
                                <div className={css.galleryMainImageContainer}>
                                    <Thumbnail
                                        asset={secondImage}
                                        hiddenAsset={isAnonymousListing}
                                        onPreviewClick={e => handleViewPhotosClick(e, 1)}
                                        imageProps={imageProps}
                                        videoProps={videoProps}
                                    />
                                </div>
                            )}

                            {galleryColumns}
                        </div>
                    )}
                    {viewPhotosButton}
                </div>
                {children}
            </div>
            {imageCarouselOpen && (
                <ModalPortal
                    id="ListingPage.imageCarousel"
                    scrollLayerClassName={css.carouselModalScrollLayer}
                    containerClassName={css.carouselModalContainer}
                    contentClassName={css.modalContent}
                    lightCloseButton
                    isOpen={imageCarouselOpen}
                    onClose={onImageCarouselClose}
                >
                    <ImageCarousel
                        selectedImageIndex={selectedImageIndex}
                        images={images}
                        variants={['landscape-crop2x']}
                        renderVideoElem={({
                            image: videoEl,
                            renderDescription,
                            description,
                            videoElem,
                            ...rest
                        }) => (
                            <AnonymCarouselPlaceholder
                                isAnonymousListing={isAnonymousListing}
                                type="horse"
                                assetElem={
                                    <>
                                        <SdkVideo
                                            {...rest}
                                            entity={videoEl}
                                            controls={false}
                                            autoPlay
                                        />
                                        {renderDescription()}
                                    </>
                                }
                            >
                                <ActionButton
                                    loading={loading || loadingProp}
                                    riderListing={riderListing}
                                    currentListing={listing}
                                    handleListingContacting={() => setInquiryModalOpen(true)}
                                >
                                    Anfrage senden
                                </ActionButton>
                            </AnonymCarouselPlaceholder>
                        )}
                        renderImageElem={({ imageElem, image }) => (
                            <AnonymCarouselPlaceholder
                                isAnonymousListing={!image.isDefaultAvatar && isAnonymousListing}
                                assetElem={imageElem}
                            >
                                <ActionButton
                                    loading={loading || loadingProp}
                                    riderListing={riderListing}
                                    currentListing={listing}
                                    handleListingContacting={() => setInquiryModalOpen(true)}
                                >
                                    Anfrage senden
                                </ActionButton>
                            </AnonymCarouselPlaceholder>
                        )}
                    />
                </ModalPortal>
            )}
        </>
    );
};

const mapStateToProps = ({ Assets: { assetsLoadingRequests } }) => ({
    assetsLoadingRequests,
});

export default compose(connect(mapStateToProps), withViewport)(SectionImages);
